export default {
    path: '/ad_location/:campaign_id/:ad_location_id',
    preload: true,
    middlewares: [{
        "rms_ui/validatePermissionsMiddleware": [
            ['marketing.ad_location_read'],
            "/"
        ]
    }],
}
